/* External dependencies */
import { gql } from '@apollo/client';

/* Local dependencies */
import { setAuthenticatedClient } from '../../../../client/graphql';
import { DeleteDeviceInput } from '../../types';

const DELETE_DEVICE = gql`
  mutation DeleteDevice($input: T26DeleteDeviceInput!) {
    T26DeleteDevice(input: $input) {
      message
    }
  }
`;

export const deleteDeviceRequest = async (input: DeleteDeviceInput): Promise<string> => {
  try {
    const client = await setAuthenticatedClient();
    const response = await client.mutate({
      mutation: DELETE_DEVICE,
      variables: { input },
    });
    return response.data.T26DeleteDevice.message;
  } catch (err) {
    console.error('Error deleting device:', err);
    throw err;
  }
}; 